import React, { useState } from 'react';

interface InputTagsProps {
  tags: string[];
  error?: string | null;
  inputClassName?: string;
  addTag: (tag: string) => void;
  removeTag: (tag: string) => void;
  maxLength?: number;
}

const InputTags: React.FC<InputTagsProps> = ({
  maxLength,
  tags,
  error,
  inputClassName,
  addTag,
  removeTag,
}) => {
  const [inputValue, setInputValue] = useState('');

  const commit = () => {
    const v = inputValue.trim();
    if (!v) return;
    addTag(v);
    setInputValue('');
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || (e as any).keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      commit();
    }
  };

  // Alguns teclados móveis não disparam corretamente o keydown do Enter.
  const handleKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || (e as any).keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      commit();
    }
  };

  // Garante o commit quando o usuário toca em "Concluído/Done".
  const handleBlur = () => {
    commit();
  };

  return (
    <div className="w-full">
      {/* <label className="block text-gray-500 text-base font-dmsans font-regular mb-2">
        Tags *
      </label> */}

      <input
        type="text"
        value={inputValue}
        inputMode="text"
        enterKeyHint="done"
        autoCorrect="off"
        autoCapitalize="none"
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        onKeyUp={handleKeyUp}
        onBlur={handleBlur}
        maxLength={maxLength}
        placeholder="Digite uma tag e pressione Enter"
        className={`relative appearance-none rounded w-full text-input text-base leading-tight ${
          error ? 'border-red-500' : 'border-none'
        } ${inputClassName}`}
      />

      {error && <p className="text-red-500 text-xs mt-1">{error}</p>}

      <div className="flex flex-wrap mt-4">
        {tags.map((tag) => (
          <div
            key={tag}
            className="bg-gray-200 rounded-lg px-3 py-1 m-1 flex items-center space-x-2"
          >
            <span>{tag}</span>
            <button
              type="button"
              onClick={() => removeTag(tag)}
              className="text-red-500 hover:text-red-700"
              aria-label={`Remover ${tag}`}
            >
              ✕
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InputTags;
